import Vue from 'vue'
import store from '@/store'

Vue.directive('number', {
  inserted: (el, binding) => {
    el.addEventListener('keydown', (event) => {
      const { arg } = binding
      const { key } = event
      if(arg == 'number' && ['+', 'e'].includes(key)) {
        event.preventDefault()
      }
    })
  }
})
Vue.directive('tooltip', function (el, binding) {
  el.onmouseenter = function (e) {
    // 创建浮层元素并设置样式
    const vcTooltipDom = document.createElement('div')
    vcTooltipDom.style.cssText = `
         overflow: auto;
         position:absolute;
         top:${e.clientY + 5}px;
         left:${e.clientX}px;
         background: rgba(0, 0 , 0, .8);
         color:#fff;
         border-radius:5px;
         padding:8px;
         display:inline-block;
         font-size:12px;
         z-index:19999
       `
    // 设置id方便寻找
    vcTooltipDom.setAttribute('id', 'vc-tooltip')
    // 将浮层插入到body中
    document.body.appendChild(vcTooltipDom)
    // 浮层中的文字
    document.getElementById('vc-tooltip').innerHTML =  binding.value
  }
  // 鼠标移出
  el.onmouseleave = function () {
    // 找到浮层元素并移出
    const vcTooltipDom = document.getElementById('vc-tooltip')
    vcTooltipDom && document.body.removeChild(vcTooltipDom)
  }
})
Vue.directive('copy',{
  /*
    bind 钩子函数，第一次绑定时调用，可以在这里做初始化设置
    el: 作用的 dom 对象
    value: 传给指令的值，也就是我们要 copy 的值
  */

  bind(el, { value }) {
    el.$value = value // 用一个全局属性来存传进来的值，因为这个值在别的钩子函数里还会用到
    let keyAltDown = false
    el.style.position = 'relative'
    let tip = document.createElement('span')
    tip.className = 'tooltip'
    // 提示框样式
    let css = {
      display: 'none',
      position: 'absolute',
      //   width: "100%",
      padding: '5px 8px',
      borderRadius: '6px',
      color: 'white',
      fontSize:'14px',
      fontWeight:'400',
      lineHeight:'18px',
      backgroundColor: '#24292E',
      textAlign: 'center',
      zIndex: 9999
    }
    let pos = setPosition(tip)
    for (const item in pos) {
      css[item] = pos[item]
    }
    setCss(tip, css)
    el.appendChild(tip)
    el.addEventListener('mouseover', ()=>{
      if(keyAltDown&&value){
        let copyVal = store.state.copy.keyAltDownCopyVal
        tip.textContent = copyVal == value?'Copy!':'Copy to Clipboard'
        tip.style.display = 'block'
      }
    })
    el.addEventListener('mouseout', ()=>{
      tip.style.display = 'none'
    })
    el.handler = () => {
      if(keyAltDown){
        if (!el.$value) {
          tip.style.display = 'none'
          return
        }
        tip.style.display = 'none'
        el.removeChild(tip)
        // 动态创建 textarea 标签
        const textarea = document.createElement('textarea')
        textarea.value = el.$value
        // 将 textarea 插入到 body 中
        document.body.appendChild(textarea)
        // 选中值并复制
        textarea.select()
        // textarea.setSelectionRange(0, textarea.value.length);
        const result = document.execCommand('Copy')
        document.body.removeChild(textarea)
        if (result) {
          tip.textContent = 'Copy!'
          tip.style.display = 'block'
          textarea.value = el.$value
          store.dispatch('copy/setKeyAltDownCopyVal',el.$value)
          setTimeout(()=>{
            el.appendChild(tip)
          },0)
        }
      }
    }
    // 绑定点击事件，就是所谓的一键 copy 啦
    document.body.addEventListener('keydown', (event)=>{
      if(event.keyCode == 18){
        keyAltDown = true
        el.classList.add('key-alt-down')
      }
    })
    document.body.addEventListener('keyup', (event)=>{
      keyAltDown = false
      tip.style.display = 'none'
      el.classList.remove('key-alt-down')
      // store.dispatch('copy/setKeyAltDownCopyVal',null)

    })
    el.addEventListener('click', el.handler)
  },
  // 当传进来的值更新的时候触发
  componentUpdated(el, { value }) {
    el.$value = value
  },
  // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    el.classList.remove('key-alt-down')
    store.dispatch('copy/setKeyAltDownCopyVal',null)
    el.removeEventListener('click', el.handler)
  },
})

// 给元素赋值样式
function setCss(obj, css) {
  for (const attr in css) {
    obj.style[attr] = css[attr]
  }
}
// 设置提示框位置样式
function setPosition(tip, pos, color) {
  switch (pos) {
    case 'bottom':
      tip.className += ' bottom'
      document.styleSheets[0].insertRule(
        `.tooltip.bottom:before{
          content: '';
          position: absolute;
          top: -5px;
          left: 50%;
          transform: translateX(-50%);
          border-bottom: 5px solid black;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
      }`,
        0
      )
      return {
        bottom: '-5%',
        left: '50%',
        transform: 'translateX(-50%) translateY(130%)'
      }
      break
    //top
    default:
      tip.className += ' top'
      document.styleSheets[0].insertRule(
        `.tooltip.top:before{
        content: '';
        position: absolute;
        bottom: -4px;
        left: 12px;
        transform: translateX(-50%);
        border-top: 5px solid #24292E;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
    }`,
        0
      )
      return {
        top: '-5%',
        left: '0',
        transform: 'translateX(0) translateY(-130%)'
      }
      break
  }
}
